// Shared attendance presentation bits. Lives here rather than in one of the
// pages because all four attendance screens (faculty list, roster, admin
// report, student view) render the same status vocabulary.
import { Badge } from "@/components/ui/badge";

// Matches SESSION_STATUSES / ATTENDANCE_STATUSES in backend/server.py.
export const SESSION_STATUS_STYLES = {
    scheduled: "bg-[#FFA81B] hover:bg-[#FFA81B] text-white",
    in_progress: "bg-[#726AF0] hover:bg-[#726AF0] text-white",
    completed: "bg-[#16A34A] hover:bg-[#16A34A] text-white",
    cancelled: "bg-[#E11D48] hover:bg-[#E11D48] text-white",
};

export const ATTENDANCE_STATUS_STYLES = {
    present: "bg-[#16A34A] hover:bg-[#16A34A] text-white",
    late: "bg-[#FFA81B] hover:bg-[#FFA81B] text-white",
    absent: "bg-[#E11D48] hover:bg-[#E11D48] text-white",
};

// Mirrors DEFAULT_ATTENDANCE_THRESHOLD in backend/server.py. Only a fallback —
// the live value comes from the settings store.
export const DEFAULT_ATTENDANCE_THRESHOLD = 75;

/** Colour a percentage against the configured low-attendance threshold, so the
 *  number a student sees agrees with the "Low" flag an admin sees. */
export function pctColor(p, threshold = DEFAULT_ATTENDANCE_THRESHOLD) {
    if (p >= threshold + 10) return "text-[#16A34A]";
    if (p >= threshold) return "text-[#FFA81B]";
    return "text-[#E11D48]";
}

export function SessionStatusBadge({ status }) {
    return (
        <Badge className={`text-[10px] uppercase tracking-wider ${SESSION_STATUS_STYLES[status] || ""}`}>
            {(status || "").replace("_", " ")}
        </Badge>
    );
}

export function AttendanceStatusBadge({ status }) {
    return (
        <Badge className={`text-[10px] uppercase tracking-wider ${ATTENDANCE_STATUS_STYLES[status] || ""}`}>
            {status}
        </Badge>
    );
}

/** Whether the UI should offer a Cancel action, mirroring cancel_session() in
 *  backend/server.py: an unsubmitted session is cancellable by any assigned
 *  staff; once submitted, cancelling is an edit and obeys the 24-hour window. */
export function canCancelSession(session, canEdit) {
    if (!session || session.status === "cancelled") return false;
    return session.submitted_at ? !!canEdit : true;
}
